import { render, staticRenderFns } from "./Errorpayments.vue?vue&type=template&id=cf925e7e&"
import script from "./Errorpayments.vue?vue&type=script&lang=js&"
export * from "./Errorpayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports